import(/* webpackMode: "eager", webpackExports: ["Analytics"] */ "/opt/build/repo/app/_app-initialization/analytics.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ExperimentsProvider"] */ "/opt/build/repo/app/_optimizely-features/ExperimentsProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClientCookieProvider"] */ "/opt/build/repo/app/_providers/cookies-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollRestoration"] */ "/opt/build/repo/app/_providers/ScrollRestoration.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
